<script lang="ts" setup>
import { DropdownItem, Icon } from '@brighterly/lib-lumee-ui'

import { useLogOut } from '@composables/pages/login/log-out.hook'

import amplitudeConfig from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

defineOptions({
  name: 'BtnLogOut',
})

const text = 'Logout'

const {
  logout,
} = useLogOut()

const setSubmit = (): void => {
  trackEvent(amplitudeConfig.events.clickLink, {
    name: 'link_log_out',
    link_text: text,
  })
  logout()
}

</script>

<template>
  <DropdownItem
    :title="text"
    role="menuitem"
    :aria-selected="undefined"
    @click="setSubmit"
  >
    <template #leading>
      <Icon
        name="arrow-left-from-bracket"
        size="md"
      />
    </template>
  </DropdownItem>
</template>
